(function() {
    'use strict';
    angular.module('mnp.filters', []);
})();
angular.module('mnp.filters').filter('tel', function() {
    'use strict';
    return function(tel) {
        if (!tel) {
            return '';
        }
        var output = tel.toString().trim().replace(/^\+/, '').replace('GSM', '0');
        if (output.match(/[^0-9]/)) {
            return tel;
        }
        var slicedValue = output.slice(0, 1);
        if ('+' === slicedValue) {
            output = output.slice(2);
        }
        slicedValue = output.slice(0, 2);
        if ('49' === slicedValue) {
            output = output.slice(2);
        }
        slicedValue = output.slice(0, 1);
        if ('0' !== slicedValue) {
            output = '0' + output;
        }
        // all numbers beginning with 015xx have a 5 digit area code
        if (null !== output.match(/^(015)/)) {
            output = output.slice(0, 5) + ' ' + output.slice(5, 8) + ' ' + output.slice(8, 10) + ' ' + output.slice(10);
        } else {
            output = output.slice(0, 4) + ' ' + output.slice(4, 7) + ' ' + output.slice(7, 9) + ' ' + output.slice(9);
        }
        return output;
    };
});

angular.module('mnp.filters').filter('providerByFlag', function() {
    'use strict';
    return function(options, flag) {
        var tempOptions = [];
        options.forEach(function(option) {
            if (flag === option.prepaidonly) {
                tempOptions.push(option);
            }
        });
        return tempOptions.length ? tempOptions : options;
    };
});

angular.module('mnp.filters').filter('mydate', function() {
    'use strict';
    return function(date) {
        // window.moment.locale('de');
        return window.moment(date, 'DD.MM.YYYY');
    };
});

angular.module('mnp.filters').filter('topProvider', function() {
    'use strict';
    return function(options, isTop) {
        var result = [];
        options.forEach(function(option) {
            if (0 === isTop && 999 === option.rank) {
                result.push(option);
            } else if (1 === isTop && 999 > option.rank) {
                result.push(option);
            }
        });
        return result;
    };
});
